import type { SuiClient } from '@mysten/sui/client';
import type { Transaction } from '@mysten/sui/transactions';

type WalletStandardTransaction = import('@mysten/wallet-standard/node_modules/@mysten/sui/transactions').Transaction;

/**
 * Casts a Sui client coming from different package roots to the canonical type.
 */
export function ensureSuiClient<T>(client: T): SuiClient {
	return client as unknown as SuiClient;
}

/**
 * Normalises a transaction value so it can be passed to wallet-standard helpers.
 */
export function toWalletStandardTransaction(transaction: Transaction | string): WalletStandardTransaction | string {
	return transaction as unknown as WalletStandardTransaction | string;
}
